import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-end sticky to-header"
  }, [_c(VBtn, _vm._b({
    attrs: {
      "color": "grey"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, 'v-btn', _vm.$config.buttonAttrs.floating, false), [_c(VIcon, [_vm._v("mdi-arrow-left")])], 1), _c(VBtn, _vm._b({
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', _vm.$config.buttonAttrs.floating, false), [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("mdi-content-save")])], 1)], 1), _c('h1', {
    staticClass: "py-6"
  }, [_vm._v("Olvasó")]), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c(VCard, {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c(VCardTitle, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-smart-card-reader-outline")]), _vm._v(" Alapadatok ")], 1), _c(VCardText, [_c(VTextField, {
    attrs: {
      "label": "Megnevezés",
      "error-messages": _vm.errors.name,
      "filled": ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c(VAutocomplete, {
    attrs: {
      "label": "Kontroller",
      "items": _vm.controllers,
      "item-text": "name",
      "item-value": "element_id",
      "error-messages": _vm.errors.controller_id,
      "filled": "",
      "value-comparator": _vm.$config.comparators.isEqual
    },
    model: {
      value: _vm.form.controller_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controller_id", $$v);
      },
      expression: "form.controller_id"
    }
  }), _c(VTextField, {
    attrs: {
      "label": "Vonal",
      "error-messages": _vm.errors.controller_line,
      "filled": ""
    },
    model: {
      value: _vm.form.controller_line,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controller_line", $$v);
      },
      expression: "form.controller_line"
    }
  }), _c(VTextField, {
    attrs: {
      "label": "Olvasó cím",
      "error-messages": _vm.errors.reader_address,
      "type": "number",
      "filled": ""
    },
    model: {
      value: _vm.form.reader_address,
      callback: function ($$v) {
        _vm.$set(_vm.form, "reader_address", $$v);
      },
      expression: "form.reader_address"
    }
  }), _c(VTextField, {
    attrs: {
      "label": "Kommunikációs cím",
      "error-messages": _vm.errors.reader_comm_address,
      "type": "number",
      "filled": ""
    },
    model: {
      value: _vm.form.reader_comm_address,
      callback: function ($$v) {
        _vm.$set(_vm.form, "reader_comm_address", $$v);
      },
      expression: "form.reader_comm_address"
    }
  })], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": 12,
      "md": 6
    }
  }, [_c(VCard, [_c(VCardTitle, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-crosshairs-gps")]), _vm._v(" Lokáció ")], 1), _c(VCardText, [_c(VAutocomplete, {
    attrs: {
      "label": "Épület",
      "error-messages": _vm.errors.building_id,
      "items": _vm.buildings,
      "item-text": "name",
      "item-value": "id",
      "filled": "",
      "value-comparator": _vm.$config.comparators.isEqual
    },
    on: {
      "change": _vm.buildingChangedEventHandler
    },
    model: {
      value: _vm.form.building_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "building_id", $$v);
      },
      expression: "form.building_id"
    }
  }), _c(VAutocomplete, {
    attrs: {
      "label": "Épület szint",
      "error-messages": _vm.errors.building_level_id,
      "items": _vm.buildingLevels,
      "item-text": "name",
      "item-value": "id",
      "filled": "",
      "value-comparator": _vm.$config.comparators.isEqual,
      "placeholder": _vm.form.building_id ? '' : 'Válasszon épületet!',
      "readonly": !_vm.form.building_id
    },
    model: {
      value: _vm.form.building_level_id,
      callback: function ($$v) {
        _vm.$set(_vm.form, "building_level_id", $$v);
      },
      expression: "form.building_level_id"
    }
  }), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": 12,
      "sm": 6
    }
  }, [_c(VTextField, {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.$config.inputMasks.createNumberMask({
        allowDecimal: true,
        decimalLimit: 7
      }),
      expression: "$config.inputMasks.createNumberMask({ allowDecimal: true, decimalLimit: 7 })"
    }],
    attrs: {
      "label": "X koordináta",
      "error-messages": _vm.errors.x_coord,
      "filled": ""
    },
    model: {
      value: _vm.form.x_coord,
      callback: function ($$v) {
        _vm.$set(_vm.form, "x_coord", $$v);
      },
      expression: "form.x_coord"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": 12,
      "sm": 6
    }
  }, [_c(VTextField, {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.$config.inputMasks.createNumberMask({
        allowDecimal: true,
        decimalLimit: 7
      }),
      expression: "$config.inputMasks.createNumberMask({ allowDecimal: true, decimalLimit: 7 })"
    }],
    attrs: {
      "label": "Y koordináta",
      "error-messages": _vm.errors.y_coord,
      "filled": ""
    },
    model: {
      value: _vm.form.y_coord,
      callback: function ($$v) {
        _vm.$set(_vm.form, "y_coord", $$v);
      },
      expression: "form.y_coord"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }